import { useMemo } from 'react';
import _debounce from 'lodash/debounce';
import { FilterValue } from 'react-table';

export const useDebouncedSetFilter = (
  setFilter: (
    updater: ((filterValue: FilterValue) => FilterValue) | FilterValue,
  ) => void,
) => useMemo(() => _debounce(setFilter, 100, { leading: true }), [setFilter]);

export const useDebouncedHandleChange = (handleChange: (e: any) => any) =>
  useMemo(() => _debounce(handleChange, 30, { leading: true }), [handleChange]);
